import type React from "react";
import type { ReactNode } from "react";
import type { Scale } from "../../styling";
import { paddings, tw } from "../../styling";

interface IPaper extends React.HTMLAttributes<HTMLDivElement> {
	children: ReactNode;
	component?: "div" | "section" | "article";
	className?: string;
	plain?: boolean;
	padding?: Scale;
}

export const Paper = ({
	children,
	component: Component = "div",
	className,
	plain,
	padding,
	...props
}: Omit<IPaper, "color">) => (
	<Component
		{...props}
		className={tw(
			"shadow-bistron rounded-lg",
			className,
			plain && "border border-solid border-[#e4e4e4] shadow-transparent print:border-none",
			padding && paddings[padding],
		)}
	>
		{children}
	</Component>
);
